import { useEffect, useState } from 'react';
import {
    Box, Grid, Paper, Typography, Select, MenuItem,
    FormControl, InputLabel
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import ApiService from '../../_services/ApiService';
import D3BarChart from '../../components/reusableComponents/D3BarChart';
import { transformData, getCurrentMonthAndWeek } from '../../components/reusableComponents/formatCardData';
import { CardSkeleton, CardSkeletonCollab, CompactCardSkeleton } from '../../components/reusableComponents/SkeletonCard';
import ReusableHeadingComponents from '../../components/reusableComponents/reusableHeadingComponents';
import { StarBorder } from '@mui/icons-material';
import ReusableButton from '../../components/reusableComponents/reusableButtonComponents';
import { useHistory, useParams } from 'react-router-dom';

const OfferAnalytics = () => {
    const location = useLocation()?.state;
    const history = useHistory();
    const { month, week } = getCurrentMonthAndWeek();
    const { offerId } = useParams();

    const [chartData, setChartData] = useState([]);
    const [chartDataApply, setChartDataApply] = useState([]);
    const [loader, setLoader] = useState(false);
    const [revnueValue, setRevnueValue] = useState('Creators');
    const [timeFrameClicks, setTimeFrameClicks] = useState('This Week');
    const [timeFrameApplied, setTimeFrameApplied] = useState('This Week');

    // const offerId = location?.eventData?.id;
    const userType = revnueValue === 'Youth' ? 'students' : 'creators';

    const openReview = () => {
        history.push(`/influencer-review/${offerId}`);
    }

    useEffect(() => {
        setLoader(true);

        const selectedWeekClicks = timeFrameClicks === 'This Week' ? week : week - 1;
        const selectedWeekApplied = timeFrameApplied === 'This Week' ? week : week - 1;

        Promise.all([
            ApiService.get('barterApplicantClick', { month, week: selectedWeekClicks }, `click_analytics/barter/${offerId}/`),
            ApiService.get('barterApplicantClick', { month, week: selectedWeekApplied }, `apply_analytics/barter/${offerId}/`)
        ])
            .then(([clickRes, applyRes]) => {
                setChartData(clickRes?.data?.data?.week_wise ? transformData(clickRes.data.data.week_wise) : []);
                setChartDataApply(applyRes?.data?.data?.week_wise ? transformData(applyRes.data.data.week_wise) : []);
            })
            .catch(console.error)
            .finally(() => setLoader(false));
    }, [month, week, offerId, revnueValue, timeFrameClicks, timeFrameApplied]);

    return (
        <Box padding={2}>
            <Box display="flex" justifyContent='space-between'>
                <ReusableHeadingComponents heading={'Offer Analytics'} />
                <FormControl size="small" sx={{ minWidth: 160 }}>
                    <InputLabel id="audience-select-label">Audience</InputLabel>
                    <Select
                        labelId="audience-select-label"
                        value={revnueValue}
                        label="Audience"
                        onChange={(e) => setRevnueValue(e.target.value)}
                    >
                        {/* <MenuItem value="Youth">Youth</MenuItem> */}
                        <MenuItem value="Creators">Creators</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Box sx={{ padding: '20px', gap: '22px', borderRadius: '8px', backgroundColor: '#FFFFFF' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: '8px', border: '1px solid #D6D6D6', overflow: 'hidden' }}>
                            {chartData.length > 0 ? (
                                <D3BarChart
                                    data={chartData}
                                    xKey="day"
                                    yKey="value"
                                    title={`${revnueValue} Clicks`}
                                    color="#8979FF"
                                    width={500}
                                    height={250}
                                    timeFrames={["This Week", "Last Week"]}
                                    selectedTimeFrame={timeFrameClicks}
                                    onTimeFrameChange={setTimeFrameClicks}
                                />
                            ) : loader ? (
                                <CardSkeleton />
                            ) : (
                                <Typography>No data</Typography>
                            )}
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: '8px', border: '1px solid #D6D6D6', overflow: 'hidden' }}>
                            {chartDataApply.length > 0 ? (
                                <D3BarChart
                                    data={chartDataApply}
                                    xKey="day"
                                    yKey="value"
                                    title={`${revnueValue} Applied Applicants`}
                                    color="#F7979A"
                                    width={500}
                                    height={250}
                                    timeFrames={["This Week", "Last Week"]}
                                    selectedTimeFrame={timeFrameApplied}
                                    onTimeFrameChange={setTimeFrameApplied}
                                />
                            ) : loader ? (
                                <CardSkeleton />
                            ) : (
                                <Typography>No data</Typography>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default OfferAnalytics;
